import { FC, useState, useEffect } from 'react';
import cx from 'classnames/bind';

import Points from '@/components/Points/Points';
import type { IQuestion } from '@/types/question';
import type { IGame } from '@/types/game';

import styles from './Header.module.scss';

interface HeaderProps {
  className?: string;
  numberQuestion: number;
  questions: IQuestion[];
  scenarios: IGame[];
  points: number;
  responseStatus: { [x: number]: boolean | null };
}

const cn = cx.bind(styles);

const Header: FC<HeaderProps> = ({
  className,
  numberQuestion,
  questions,
  scenarios,
  points,
  responseStatus,
}) => {
  const [allPoints, setAllPoints] = useState<number>(0);

  useEffect(() => {
    if (scenarios?.length) {
      const pointsReceived = scenarios.reduce(
        (acc, current) => acc + current.score,
        0,
      );
      setAllPoints(pointsReceived + points);
    }
  }, []);

  return ((
    <div className={cn('header', className)}>
      <div className={cn('questions')}>
        {questions.map((_item, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={
              index + 1 === numberQuestion
                ? cn(
                  'question',
                  'question-active',
                  responseStatus[index] === true ? 'question-success' : '',
                  responseStatus[index] === false
                    ? 'question-unsuccess'
                    : '',
                )
                : cn(
                  'question',
                  responseStatus[index] === true ? 'question-success' : '',
                  responseStatus[index] === false
                    ? 'question-unsuccess'
                    : '',
                )
            }
          />
        ))}
      </div>
      <Points size="large" points={allPoints}/>
    </div>
  ));
};

export default Header;
